import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import '@/App.css';
import { api } from '@/lib/api';
import Login from '@/pages/Login';
import Shell from '@/components/Shell';
import Overview from '@/pages/Overview';
import Cases from '@/pages/Cases';
import Crew from '@/pages/Crew';
import Reminders from '@/pages/Reminders';
import Analytics from '@/pages/Analytics';
import Admin from '@/pages/Admin';
import AuditLog from '@/pages/AuditLog';

export default function App() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api('/auth/me').then(setUser).catch(() => setUser(null));
  }, []);

  if (user === undefined) return <div className="loading">Loading workspace…</div>;
  if (!user) {
    return (
      <BrowserRouter>
        <Routes><Route path="*" element={<Login onLogin={setUser} />} /></Routes>
      </BrowserRouter>
    );
  }
  return (
    <BrowserRouter>
      <Shell user={user}>
        <Routes>
          <Route path="/" element={<Overview user={user} />} />
          <Route path="/cases" element={<Cases user={user} />} />
          <Route path="/crew" element={<Crew user={user} />} />
          <Route path="/reminders" element={<Reminders />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/admin" element={<Admin user={user} />} />
          <Route path="/audit" element={<AuditLog user={user} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>
    </BrowserRouter>
  );
}
